module.exports = __webpack_public_path__ + "media/images/plus-icon-46bab62628f8a1f62b58031c56c27982.png";